import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-founder-invitation-success-modal',
  templateUrl: './founder-invitation-success-modal.component.html',
  styleUrls: ['./founder-invitation-success-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FounderInvitationSuccessModalComponent implements OnInit {
  @Input() founderCount: number = 1;
  @Input() entityType: string = 'Proposition';

  get memberLabel(): string {
    return this.founderCount === 1 ? 'a Member' : `${this.founderCount} Members`;
  }

  get founderLabel(): string {
    return this.founderCount === 1 ? 'a Founder' : 'Founders';
  }

  get invitationMessage(): string {
    return `You have Invited ${this.memberLabel} to be ${this.founderLabel} in your ${this.entityType}`;
  }

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
